import { FC } from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';

import { FormProvider } from '@carcareers/contexts';
import { RequestRecruiterForm } from '@carcareers/components';

interface RequestARecruiterModalProps {
  open: boolean;
  onClose: () => void;
}

export const RequestARecruiterModal: FC<RequestARecruiterModalProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
            <RequestRecruiterForm onSuccess={onClose} onClose={onClose} />
          </Box>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

export default RequestARecruiterModal;
